import { useMemo } from 'react';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { BlockHeader } from 'components/blocks/BlockHeader';
import { BlockContent } from 'components/blocks/BlockContent';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { IResortPathInfo, IResortSnowReportTerrain } from 'api/resort/types';
import { useBuildTerrainIcons } from 'components/resort/Terrain/useBuildTerrainIcons';
import { Routes } from 'routes';
import { NextLinkTr } from 'components/blocks/NextLink';
import { activeRunsChecking } from 'util/terrainActiveRunChecking';
import { isMainLocale } from 'util/i18nFlags';
import styles from './styles.module.scss';

export const Terrain = ({
  isFresh,
  data,
  pathInfo,
  resortCountry,
}: {
  isFresh: boolean,
  data: IResortSnowReportTerrain,
  pathInfo: IResortPathInfo,
  resortCountry?: string
}) => {
  const { t } = useOTSTranslation('common');
  const isShowLinkToOverview = isMainLocale();
  const icons = useBuildTerrainIcons({
    data: {
      advanced: data.runsAdvanced,
      beginner: data.runsBeginner,
      expert: data.runsExpert,
      intermediate: data.runsIntermediate,
      acres: data.acres,
      canReturnBySki: data.canReturnBySki,
      km: data.km,
      runs: data.runs,
    },
    resortCountry,
  });
  const show = icons.filter((i) => !!i).length > 0;
  const hasTerrainData = useMemo(() => activeRunsChecking(data), [data]);

  if (!show || !hasTerrainData) {
    return null;
  }

  return (
    <BoxWithShadow>
      <BlockHeader useH3 title={t('resort.skiReport.terrain')}>
        {isShowLinkToOverview && (
          <NextLinkTr href={Routes.resortTripPlanningTrailMap(pathInfo)}>
            {t('resort.skiReport.terrainOverview')}
          </NextLinkTr>
        )}
      </BlockHeader>
      <BlockContent blur={!isFresh}>
        <div className={styles.box}>
          {icons}
        </div>
      </BlockContent>
    </BoxWithShadow>
  );
};
